// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/update/v1/ota.proto (package msh.trait.update.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.update.v1.OtaTrait
 */
export const OtaTrait = proto3.makeMessageType(
  "msh.trait.update.v1.OtaTrait",
  [],
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.update.v1.OtaTrait.Command
 */
export const OtaTrait_Command = proto3.makeMessageType(
  "msh.trait.update.v1.OtaTrait.Command",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "incremental_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "OtaTrait_Command"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.update.v1.OtaTrait.RequestEvent
 */
export const OtaTrait_RequestEvent = proto3.makeMessageType(
  "msh.trait.update.v1.OtaTrait.RequestEvent",
  () => [
    { no: 1, name: "model_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "incremental_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "requested_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "OtaTrait_RequestEvent"},
);

/**
 * @generated from message msh.trait.update.v1.OtaTrait.UpdateFailEvent
 */
export const OtaTrait_UpdateFailEvent = proto3.makeMessageType(
  "msh.trait.update.v1.OtaTrait.UpdateFailEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "retry", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "current_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "requested_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "OtaTrait_UpdateFailEvent"},
);

